module.exports = __webpack_public_path__ + "img/screenshot-2.df18e714.png";